import createClient from 'openapi-fetch';
import type { paths } from './types';

export const apiClient = createClient<paths>({
  baseUrl: (import.meta.env.VITE_API_URL || 'https://calwmp-backend-staging.jed-22a.workers.dev') + '/api/v1',
});

export type ApiPaths = paths;
